module.exports = __webpack_public_path__ + "img/workflow.0a6cd88e.png";